import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSocialLinks } from '../utils/socialLinks';

function readUser() {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem('adeeb-user') : null;
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/* ── Inline SVG icons (no extra deps) ────────────────────────────── */

const IconBooks = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);
const IconTag = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41 13 21a2 2 0 0 1-2.83 0L2 12.83V2h10.83L21 10.17a2 2 0 0 1-.41 3.24z" />
    <circle cx="7" cy="7" r="1.4" fill="currentColor" stroke="none" />
  </svg>
);
const IconUser = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const IconMail = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <polyline points="3 7 12 13 21 7" />
  </svg>
);
const IconChevron = () => (
  <svg viewBox="0 0 24 24" width="10" height="10" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 6 15 12 9 18" />
  </svg>
);
const IconHeart = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" fill="currentColor">
    <path d="M12 21s-7-4.35-9.33-9.06C1.05 8.46 3.36 5 7 5c2.04 0 3.32 1.02 5 3 1.68-1.98 2.96-3 5-3 3.64 0 5.95 3.46 4.33 6.94C19 16.65 12 21 12 21z" />
  </svg>
);
const IconTop = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="18 15 12 9 6 15" />
  </svg>
);

/* ── Social icons ─────────────────────────────────────────────── */

const Social = {
  instagram: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="currentColor">
      <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.89h-2.33v6.99A10 10 0 0 0 22 12z" />
    </svg>
  ),
  x: (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="currentColor">
      <path d="M18.244 2H21l-6.51 7.44L22 22h-6.81l-4.74-6.18L4.93 22H2.17l6.97-7.97L2 2h6.94l4.29 5.67L18.244 2zm-2.39 18h1.91L7.24 4h-2L15.85 20z" />
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="currentColor">
      <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z" />
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" fill="currentColor">
      <path d="M19.5 7.6a6.7 6.7 0 0 1-3.9-1.25v8.55a5.95 5.95 0 1 1-5.95-5.95c.32 0 .63.03.93.08v3.06a2.94 2.94 0 1 0 2.06 2.81V2h2.96a4 4 0 0 0 .27 1.45 4 4 0 0 0 1.04 1.5 4 4 0 0 0 2.59 1.05V7.6z" />
    </svg>
  ),
};

export default function Footer() {
  const location = useLocation();
  const [user, setUser] = useState(readUser);
  const socials = useSocialLinks();

  useEffect(() => {
    const refresh = () => setUser(readUser());
    window.addEventListener('storage', refresh);
    window.addEventListener('adeeb-auth-change', refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('adeeb-auth-change', refresh);
    };
  }, []);

  if (location.pathname.startsWith('/read/')) return null;

  const year = new Date().getFullYear();

  const FooterLink = ({ to, children }) => (
    <li>
      <Link to={to}>
        <span className="site-footer-bullet"><IconChevron /></span>
        {children}
      </Link>
    </li>
  );

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer-glow" aria-hidden="true" />

      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <Link to="/" className="site-footer-mark" aria-label="Deenlit home"><img className="site-footer-logo" src="/branding/deenlit-logo.png" alt="DeenLit" width="2172" height="724" loading="lazy" /></Link>
          <div className="site-footer-tag">A World of Stories</div>
          <p className="site-footer-blurb">
            Beautifully illustrated bilingual stories — narrated in English and Arabic for young readers.
          </p>
          <div className="site-footer-ornament">&#10040; &#10040; &#10040;</div>

          {socials.length > 0 && <div className="site-footer-socials" aria-label="Social links">
            {socials.map((s) => (
              <a
                key={s.id}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`site-footer-social s-${s.id}`}
                aria-label={s.label}
                title={s.label}
              >
                {Social[s.id]}
              </a>
            ))}
          </div>}
        </div>

        <div className="site-footer-col">
          <h4 className="site-footer-title"><span className="site-footer-title-icon"><IconBooks /></span>Browse</h4>
          <ul className="site-footer-links">
            <FooterLink to="/category/all">Library</FooterLink>
            <FooterLink to="/category/popular">Popular</FooterLink>
            <FooterLink to="/category/topRated">Highest Rated</FooterLink>
            <FooterLink to="/category/newArrivals">New Arrivals</FooterLink>
            <FooterLink to="/about">About us</FooterLink>
            <FooterLink to="/contact">Contact us</FooterLink>
            <FooterLink to="/privacy">Privacy Policy</FooterLink>
            <FooterLink to="/terms">Terms and Conditions</FooterLink>
          </ul>
        </div>

        <div className="site-footer-col">
          <h4 className="site-footer-title"><span className="site-footer-title-icon"><IconTag /></span>Categories</h4>
          <ul className="site-footer-links">
            <FooterLink to="/category/fiction">Fiction</FooterLink>
            <FooterLink to="/category/nonFiction">Non-fiction</FooterLink>
            <FooterLink to="/category/islam">Islam</FooterLink>
            <FooterLink to="/category/poems">Poems</FooterLink>
            <FooterLink to="/category/history">History</FooterLink>
          </ul>
        </div>

        <div className="site-footer-col">
          <h4 className="site-footer-title"><span className="site-footer-title-icon"><IconUser /></span>Account</h4>
          <ul className="site-footer-links">
            {user ? (
              <>
                <FooterLink to="/profile">My Shelf</FooterLink>
                <FooterLink to="/profile">Favourite Books</FooterLink>
                <FooterLink to="/profile">Reading Progress</FooterLink>
              </>
            ) : (
              <>
                <FooterLink to="/login">Login</FooterLink>
                <FooterLink to="/register">Sign up</FooterLink>
                <FooterLink to="/forgot-password">Reset password</FooterLink>
              </>
            )}
            <FooterLink to="/school-portal">School portal</FooterLink>
            <FooterLink to="/school-join">Join as a school</FooterLink>
          </ul>
          <a className="site-footer-mail" href="mailto:support@deenlit.com">
            <IconMail /> support@deenlit.com
          </a>
        </div>
      </div>

      <div className="site-footer-bottom">
        <span className="site-footer-bottom-left">
          &copy; {year} Deenlit &middot; a world of stories
        </span>
        <span className="site-footer-bottom-mid">
          Made with <span className="site-footer-heart"><IconHeart /></span> for young readers
        </span>
        <button
          type="button"
          className="site-footer-top"
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <IconTop /> <span>Top</span>
        </button>
      </div>
    </footer>
  );
}
